import React, { FC } from 'react';
import { HeadingBlock } from '@design-system/heading-block';
import { PromoFormBlock } from '@design-system/promo-form-block';

import { AirwickNewsletterFormProps } from '../models';

export const AirwickNewsletterForm: FC<AirwickNewsletterFormProps> = ({
  headline,
  description,
  form,
  onFormSent,
}) => (
  <section className="info">
    <HeadingBlock
      className="newsletter-headline"
      headlineTag="h3"
      headlineVariant="headline"
      headlineSize="s"
      headlineWeight="medium"
      align="start"
      headline={headline}
      description={description}
    />
    <section>
      <PromoFormBlock
        {...{
          className: 'newsletter-promo-form',
          url: form.url,
          formId: form.id,
          submitErrorMessage: form.submitErrorMessage,
          showHeading: false,
        }}
        onSuccessCallback={onFormSent}
        disabled={false}
      />
    </section>
  </section>
);
